/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterTemplateListViewModel } from '../../models/setup-parameter-template-list-view-model';
import { SetupParameterType } from '../../models/setup-parameter-type';

export interface GetSetupParameterTemplates$Params {
  setupParameterTemplateId?: number | null;
  setupParameterType?: SetupParameterType | null;
  externalSetupKindUsageId?: string | null;
  setupParameterKindId?: number | null;
}

export function getSetupParameterTemplates(http: HttpClient, rootUrl: string, params?: GetSetupParameterTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SetupParameterTemplateListViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterTemplates.PATH, 'get');
  if (params) {
    rb.query('setupParameterTemplateId', params.setupParameterTemplateId, {});
    rb.query('setupParameterType', params.setupParameterType, {});
    rb.query('externalSetupKindUsageId', params.externalSetupKindUsageId, {});
    rb.query('setupParameterKindId', params.setupParameterKindId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SetupParameterTemplateListViewModel>>;
    })
  );
}

getSetupParameterTemplates.PATH = '/api/v1/SetupParameter/GetSetupParameterTemplates';
